import { Component, OnInit } from '@angular/core';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { Message } from 'src/app/message';
import { globals } from '../../../globals/globals';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  // headerFooterHide: boolean = false;

  constructor(
    // private broadcastService: BroadcastService,
    // private analytics: AngularFireAnalytics
  ) {
    // this.broadcastService.on(new Message('androidplans', null)).subscribe(event => this.plansAndroidHeader());
   }

  ngOnInit(): void {
  }

  // plansAndroidHeader(){
  //   this.headerFooterHide = true;
  // }

  /*newWindowRoutes(route){
    window.open(globals.site+route+'?browser=mobile', '_blank');
  }*/
 newWindowRoutes(route){
  window.open(window.location.origin + '/' + route + '?browser=mobile', '_blank');
}
  

  externalRedirect(url, title){
    // this.analytics.logEvent('app_events_click', {
    //   e_v:1, typ:'connect with us', vst:title, app: 'web', 
    //   m_g: 'NA', e_t: 'click', title: title,
    //   u_st:window.localStorage.getItem('otv_user_analytic_id') ? 'registered' : 'anonymous', u_p: 'NA', 
    //   u_p_r: 'NA', u_id: window.localStorage.getItem('otv_user_analytic_id')
    // });
    window.open(url+'?browser=mobile', '_blank');
  }


}
